import employeeapi from "../../../../services/employee";

export const fetchResignationNoticesApi = async (page, size, filters) => {
  let url = `ResignationNotices/by-branch?page=${page}&size=${size}`;
  if (filters && filters.field && filters.value && filters.operator !== "") {
    url += `&field=${filters.field}&value=${filters.value}&operator=${filters.operator}`;
  }
  const response = await employeeapi.get(url);
  return response.data;
};
